export default [
  {
    title: "Customer Management",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Customer List",
        route: "custom-module",
        path: "/custom-module/custom-customer-list",
      },
    ],
  },
];
